export enum LogEventType{
  ChatFormOffer = 5,
  ChatFormDecline = 6,
  ChatFormSubmit = 7
}
